<template>
  <el-card shadow="never" class="sidebar-card hot-topics">
    <template #header>
      <div class="card-title">热门话题</div>
    </template>
    <div v-if="topics.length" class="hot-topic-list">
      <button
        v-for="(topic, idx) in topics"
        :key="topic.id"
        type="button"
        class="hot-topic-item"
        @click="$emit('select', topic.id)"
      >
        <span class="hot-topic-rank" :class="{ 'is-top': idx < 3 }">{{ idx + 1 }}</span>
        <span class="hot-topic-name">{{ topic.name }}</span>
        <span class="hot-topic-heat" :title="`热度 ${heatOf(topic)}`">
          <IconFlame class="hot-topic-heat-icon" />
          <span class="hot-topic-heat-num">{{ heatOf(topic) }}</span>
        </span>
      </button>
    </div>
    <el-empty v-else description="暂无话题" :image-size="64" />
  </el-card>
</template>

<script>
import IconFlame from "@/components/icons/IconFlame.vue";

export default {
  name: "HotTopics",
  components: { IconFlame },
  props: {
    topics: { type: Array, default: () => [] },
  },
  emits: ["select"],
  methods: {
    heatOf(topic) {
      const n = Number(topic?.heat);
      return Number.isFinite(n) && n > 0 ? n : 0;
    },
  },
};
</script>

<style scoped>
.hot-topics :deep(.el-card__header) {
  padding: 14px 16px;
}

.hot-topics :deep(.el-card__body) {
  padding: 0 8px 12px;
}

.hot-topic-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: none;
  background: transparent;
  padding: 10px 8px;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
}

.hot-topic-item:hover {
  background: var(--el-fill-color-light);
}

.hot-topic-rank {
  width: 18px;
  flex-shrink: 0;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: var(--el-text-color-secondary);
}

.hot-topic-rank.is-top {
  color: var(--el-color-primary);
}

.hot-topic-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: var(--el-text-color-primary);
}

.hot-topic-heat {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  font-size: 13px;
  color: var(--el-text-color-secondary);
  line-height: 1;
}

.hot-topic-heat-icon {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  color: inherit;
}

.hot-topic-heat-num {
  font-variant-numeric: tabular-nums;
  min-width: 1em;
  font-weight: 400;
}
</style>
